// extracted by mini-css-extract-plugin
export default {"scrollDowns":"Scroll_scrollDowns__LCdQb","mousey":"Scroll_mousey__VqjIP","scroller":"Scroll_scroller__SN-Bc","scroll":"Scroll_scroll__S9P8R"};